import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Typography } from '@mui/material';
import ContentRenderer from '../Smart/Content/ContentRenderer';
import { RootState } from '../../redux/store';
import { IEntityContentField } from '../../lib/interfaces/Common';
import { FIELD_TYPES } from '../Form/form.utils';
import './CourseInfo.scss';
import paths from '../../lib/consts/paths';

const CourseInfo = () => {
	const { courseData } = useSelector((state: RootState) => state.ui.course);
	const { i18n } = useTranslation();
	const currentLanguage: string = i18n.language;
	const contentFields: IEntityContentField[] | undefined =
		courseData?.content[currentLanguage];

	return (
		<div>
			{courseData && (
				<div className="CourseInfo">
					<Link to={paths.courses}>
						<KeyboardArrowLeftIcon
							sx={{
								color: 'rgba(171, 171, 171, 0.5)',
								fontSize: '30px',
								marginRight: '5px',
								'&:hover': {
									color: 'rgba(171, 171, 171, 0.8)',
								},
							}}
						/>
					</Link>
					{courseData.imageUrl && (
						<img
							src={courseData.imageUrl}
							alt={courseData.name}
							className="CourseInfo__img"
						/>
					)}
					<div className="CourseInfo__content">
						{contentFields?.map((field) => {
							if (field.type === FIELD_TYPES.TEXT) {
								return (
									<Typography
										sx={{
											fontWeight: '500',
											// color: '#ffffff',
											lineHeight: '130%',
											fontSize: '1.25rem',
										}}
										variant="h5"
										component="h2"
										key={field.name}
									>
										{field.content}
									</Typography>
								);
							}
							if (field.type === FIELD_TYPES.RICH_EDITOR) {
								return (
									<ContentRenderer
										// textColor="#ffffff"
										html={field.content}
										key={field.name}
									/>
								);
							}
							return null;
						})}
					</div>
				</div>
			)}
		</div>
	);
};

export default CourseInfo;
